'use client';

import {
  Cookie as CookieClient,
  createRealTimeCookie,
} from '@cookie-baker/browser';
import type { CartItem } from '@generated-client/backend';
import { Action, action, Atom } from '@reatom/core';
import { atom } from '@reatom/framework';
import { reatomCookie } from '@reatom/npm-cookie-baker';
import { cartAtom, likeEffect, likesAtom } from '@trwl/store';
import { referrerNameAction, saveCartItemsAction } from '@trwl/store/actions';

type AuthCookieModel = {
  accessToken?: string;
  refreshToken?: string;
  referrerId?: string;
  visitorId?: string;
};

let authAtom: { cookieAtom: Atom<AuthCookieModel>; set: Action };
if (typeof window !== 'undefined') {
  const cookie = new CookieClient<AuthCookieModel>();
  const realTimeCookie = createRealTimeCookie(cookie);

  authAtom = reatomCookie(cookie, realTimeCookie);

  authAtom.cookieAtom.onChange((ctx: any, newState: AuthCookieModel) => {
    const referrerId = newState.referrerId;
    const referrerIdNumber = parseInt(referrerId || '');
    referrerNameAction(
      ctx,
      isNaN(referrerIdNumber) ? undefined : referrerIdNumber,
    );
  });
} else {
  authAtom = {
    cookieAtom: atom(() => ({}), 'dummyCookieAtom'),
    set: action(),
  };
}

export { authAtom };
export const isAuthedAtom = atom((ctx) => {
  const cookieObject = ctx.spy(authAtom.cookieAtom);
  return !!cookieObject.accessToken;
});

export const onLoginAction = action(async (ctx) => {
  const cart = ctx.get(cartAtom);
  const likes = ctx.get(likesAtom);
  const cartItems: CartItem[] = cart.map((i) => ({
    variantId: i.id,
    deliveryType: i.deliveryType,
    count: i.count,
  }));
  await saveCartItemsAction(ctx, { cartItems });

  const likeProductIds = likes.map((p) => p.id).reverse();
  await likeEffect(ctx, likeProductIds);
  likesAtom(ctx, []);
});
